import React, { useContext, useEffect, useState } from 'react';
import { ServiceResponse } from '../../../app/services/shared/interfaces';
import LazyLoading from '../../../components/LazyLoading';
import { AppContext } from '../../../contexts/AppContext';
import useReactConfirmAlert from '../../../hooks/useReactConfirmAlert';
import { toast } from 'react-toastify';
import { ItemCategory } from '../../../app/models/ItemCategory';
import useItemCategoryService from '../../../app/services/hooks/useItemCategoryService';
import ItemCategoryFormContainer from './ItemCategoryFormContainer';

interface Props {
    categoryId: number;
    onSaved?: () => void;
    onCancel?: () => void;
    onError?: () => void;
}

const ItemCategoryEdit = ({ categoryId, onSaved, onCancel, onError }: Props) => {
    const { showLoading, hideLoading } = useContext(AppContext);
    const { fetchingEditCategory, editCategory, fetchingUpdateCategory, updateCategory } =
        useItemCategoryService();

    const [category, setCategory] = useState<ItemCategory>({ name: '' });
    const [errorFields, setErrorFields] = useState<any>();

    useEffect(() => {
        edit();
    }, []);

    const edit = () => {
        if (showLoading) showLoading('loading', 'Cargando categoría...');
        editCategory(categoryId, {
            onSuccess: (response: ServiceResponse) => {
                setCategory(response.data.item_category);
                if (hideLoading) hideLoading();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                toast.error(response.message);
                if (onError) onError();
            }
        });
    };

    const update = () => {
        if (showLoading) showLoading('loading', 'Actualizando categoría...');
        updateCategory(categoryId, category, {
            onSuccess: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                useReactConfirmAlert().successAlert({
                    title: 'Éxito',
                    message: response.message
                });
                toast.success(response.message, { autoClose: 2500 });
                if (onSaved) onSaved();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                useReactConfirmAlert().errorAlert({
                    title: 'Error',
                    message: response.message
                });
            },
            onFieldError: (errorFields: ServiceResponse) => {
                if (hideLoading) hideLoading();
                setErrorFields(errorFields.data);
            }
        });
    };

    const cancel = () => {
        if (onCancel) onCancel();
    };

    return fetchingEditCategory ? (
        <LazyLoading height="300" />
    ) : (
        <ItemCategoryFormContainer
            fetching={fetchingUpdateCategory}
            action={update}
            cancel={cancel}
            category={category}
            setCategory={setCategory}
            errorFields={errorFields}
        />
    );
};

export default ItemCategoryEdit;
